import { GridIntermediateData } from 'src/components/AdManager/Search/Models/GridIntermediateData';

export class DataForGroupByField {
  public portfolioGridIntermediateData: GridIntermediateData;
}
